import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import clsx from 'clsx'
import { box, rule, sidebarContent, styles } from 'leds'
import React from 'react'

import { AccordionGroup } from '../../Accordion/AccordionGroup'
import { SidebarItemIcon } from '../Item/SidebarItemIcon'
import { SidebarItemLabel } from '../Item/SidebarItemLabel'
import { SidebarProduct } from '../Item/SidebarProduct'
import { SidebarSubItem } from '../Item/SidebarSubItem'
import { SidebarProps } from '../SidebarProps'

interface MenuProps extends SidebarProps {
  expand: boolean
  onToggleSidebar?: () => void
  className?: string
}

export const SidebarMenu: React.FC<MenuProps> = ({
  expand,
  navigation,
  products,
  selectedProduct,
  selectedNavigation,
  onToggleSidebar,
  className,
}) => {
  const t = useStaticText()

  const productLabel = selectedProduct
    ? `${selectedProduct.productLine} ${selectedProduct.segment}`
    : t.search.products

  const selectedItemIndex = navigation.findIndex((item) => item.type === selectedNavigation)

  return (
    <div
      className={clsx(
        sidebarContent({ state: expand ? 'expanded' : 'collapsed' }),
        styles({
          paddingBottom: 50,
          overscrollBehavior: 'contain',
        }),
        className
      )}
    >
      {expand ? (
        <SidebarProduct label={productLabel} products={products} />
      ) : (
        <SidebarItemIcon
          icon={'BOX'}
          label={productLabel}
          onClick={() => {
            onToggleSidebar?.()
          }}
        />
      )}
      {Boolean(navigation.length) && (
        <div className={styles({ paddingBottom: { screenXS: 50, screenM: 5 } })}>
          <div className={styles({ paddingX: 16 })}>
            <hr className={rule({ direction: 'horizontal', background: 'grey5' })} />
          </div>
          <ul className={box()}>
            {expand ? (
              <AccordionGroup
                accordionButtonClassname={styles({ paddingRight: 16 })}
                accordionClassName={(accordionIndex) =>
                  styles({
                    background: selectedItemIndex === accordionIndex ? 'whiteBlue' : 'grey1',
                  })
                }
                allowMultipleOpen={true}
                initialOpenIndex={selectedItemIndex}
                items={navigation.map((item) => {
                  const selected = selectedNavigation === item.type

                  return {
                    content: (
                      <ul className={styles({ listStyle: 'none', padding: 0 })}>
                        {item.items.map((it) => (
                          <SidebarSubItem item={it} key={it.label} />
                        ))}
                      </ul>
                    ),
                    label: <SidebarItemLabel item={item} selected={selected} />,
                    itemId: item.label,
                  }
                })}
              />
            ) : (
              <>
                {navigation.map((item, key) => (
                  <SidebarItemIcon
                    icon={item.icon}
                    key={key}
                    label={item.label}
                    onClick={() => {
                      onToggleSidebar?.()
                    }}
                    selected={selectedNavigation === item.type}
                  />
                ))}
              </>
            )}
          </ul>
        </div>
      )}
    </div>
  )
}
